import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import TypeBadge from '../../components/TypeBadge';
import api from '../../api/ApiClient';

const FILTERS = ['all', 'completed', 'disputed', 'refunded'];

export default function MyPurchases() {
  const [orders, setOrders] = useState([]);
  const [filter, setFilter] = useState('all');
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.getOrders('bought').then(d => setOrders(d.orders || [])).finally(() => setLoading(false));
  }, []);

  const filtered = filter === 'all' ? orders : orders.filter(o => o.status === filter);

  return (
    <div>
      <h1 style={{ fontSize: 22, fontWeight: 700, color: 'var(--text)', letterSpacing: '-0.5px', marginBottom: 24 }}>Purchases</h1>

      {/* Filter tabs */}
      <div style={{ display: 'flex', gap: 6, marginBottom: 20 }}>
        {FILTERS.map(f => (
          <button key={f} onClick={() => setFilter(f)} style={{
            padding: '5px 14px', borderRadius: 6, cursor: 'pointer', fontSize: 13, fontWeight: 500,
            textTransform: 'capitalize', fontFamily: 'inherit',
            border: `1px solid ${filter === f ? 'var(--accent)' : 'var(--border)'}`,
            background: filter === f ? 'var(--accent-bg)' : 'var(--surface)',
            color: filter === f ? 'var(--accent)' : 'var(--text-2)',
          }}>{f}</button>
        ))}
      </div>

      {loading && <div style={{ color: 'var(--text-3)' }}>Loading…</div>}

      {!loading && filtered.length === 0 && (
        <div className="card" style={{ padding: '60px 24px', textAlign: 'center' }}>
          <p style={{ color: 'var(--text-2)' }}>
            {filter === 'all'
              ? <><span>No purchases yet. </span><Link to="/" style={{ color: 'var(--accent)' }}>Browse the marketplace</Link></>
              : `No ${filter} orders.`}
          </p>
        </div>
      )}

      {!loading && filtered.length > 0 && (
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(280px, 1fr))', gap: 14, alignItems: 'stretch' }}>
          {filtered.map(o => {
            const a = o.assetId || {};
            const stColor = o.status === 'completed' ? '#16A34A' : o.status === 'disputed' ? '#DC2626' : '#64748B';
            const stBg    = o.status === 'completed' ? '#F0FDF4' : o.status === 'disputed' ? '#FEF2F2' : '#F1F5F9';
            return (
              <div key={o._id} className="card" style={{ padding: 18, display: 'flex', flexDirection: 'column' }}>
                <div style={{ display: 'flex', gap: 12, marginBottom: 12 }}>
                  {a.previewImage
                    ? <img src={a.previewImage} alt="" style={{ width: 56, height: 56, borderRadius: 8, objectFit: 'cover', flexShrink: 0, border: '1px solid var(--border)' }} />
                    : <div style={{ width: 56, height: 56, borderRadius: 8, background: 'var(--surface2)', flexShrink: 0 }} />
                  }
                  <div style={{ flex: 1, overflow: 'hidden' }}>
                    <div style={{ fontSize: 13, fontWeight: 600, color: 'var(--text)', marginBottom: 4, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                      {a.title || 'Unknown'}
                    </div>
                    {a.assetType && <TypeBadge type={a.assetType} size="sm" />}
                  </div>
                </div>

                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 12 }}>
                  <span style={{ fontFamily: 'Space Mono', fontWeight: 700, fontSize: 15, color: 'var(--text)' }}>
                    ${o.amount}
                  </span>
                  <div style={{ display: 'flex', gap: 8, alignItems: 'center' }}>
                    <span style={{ fontSize: 11, padding: '2px 7px', borderRadius: 4, fontWeight: 600, color: stColor, background: stBg }}>{o.status}</span>
                    <span style={{ fontSize: 11, color: 'var(--text-3)' }}>{new Date(o.createdAt).toLocaleDateString()}</span>
                  </div>
                </div>

                <div style={{ display: 'flex', gap: 8, marginTop: 'auto' }}>
                  <Link to={`/asset/${a._id}`} style={{
                    flex: 1, padding: '7px', textAlign: 'center', borderRadius: 6,
                    background: 'var(--accent-bg)', color: 'var(--accent)',
                    textDecoration: 'none', fontSize: 12, fontWeight: 600, border: '1px solid #BFDBFE',
                  }}>View</Link>
                  {o.status === 'completed' && (
                    <Link to={`/asset/${a._id}`} style={{
                      flex: 1, padding: '7px', textAlign: 'center', borderRadius: 6,
                      background: '#F0FDF4', color: '#16A34A',
                      textDecoration: 'none', fontSize: 12, fontWeight: 600, border: '1px solid #BBF7D0',
                    }}>Download</Link>
                  )}
                </div>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
}
